export default __webpack_public_path__ + "static/media/EventLandingPage.59c98190.jpeg";